import { useState } from 'react';
import { createVessel, updateVessel } from './api';

const FIELDS = [
  { key: 'ship_name', label: 'Ship Name', required: true, col: 2 },
  { key: 'imo_number', label: 'IMO Number', required: true },
  { key: 'call_sign', label: 'Call Sign' },
  { key: 'mmsi', label: 'MMSI' },
  { key: 'flag', label: 'Flag' },
  { key: 'port_of_registry', label: 'Port of Registry' },
  { key: 'ship_type', label: 'Type of Ship' },
  { key: 'gross_tonnage', label: 'Gross Tonnage' },
  { key: 'net_tonnage', label: 'Net Tonnage' },
  { key: 'deadweight', label: 'Deadweight' },
  { key: 'loa', label: 'Length Overall' },
  { key: 'beam', label: 'Beam' },
  { key: 'hull_type', label: 'Hull Type' },
  { key: 'year_of_build', label: 'Year of Build' },
  { key: 'class_register', label: 'Class Register' },
  { key: 'previous_name', label: 'Previous Name' },
  { key: 'owner_manager', label: 'Owner / Manager', col: 2 },
  { key: 'owner_address', label: 'Owner Address', col: 2 },
];

export default function VesselForm({ vessel, setPage, onLogout }) {
  const isEdit = !!vessel;
  const [form, setForm] = useState(vessel || {});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (key, val) => setForm(f => ({ ...f, [key]: val }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      if (isEdit) {
        await updateVessel(vessel.imo_number, form);
      } else {
        await createVessel(form);
      }
      setPage('dashboard');
    } catch (err) {
      if (err.response?.status === 401) onLogout();
      setError(err.response?.data?.detail || 'An error occurred.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.wrapper}>
      <header style={styles.header}>
        <button style={styles.backBtn} onClick={() => setPage('dashboard')}>Back</button>
        <div style={styles.headerTitle}>{isEdit ? 'Edit Vessel' : 'Add New Vessel'}</div>
        <div style={styles.headerBadge}>VESSEL PARTICULARS</div>
      </header>
      <main style={styles.main}>
        <form onSubmit={handleSubmit}>
          <div style={styles.grid}>
            {FIELDS.map(f => (
              <div key={f.key} style={{ ...styles.field, gridColumn: f.col === 2 ? 'span 2' : 'span 1' }}>
                <label style={styles.label}>
                  {f.label.toUpperCase()}
                  {f.required && <span style={{ color: 'var(--red)' }}> *</span>}
                </label>
                <input
                  style={styles.input}
                  value={form[f.key] || ''}
                  onChange={e => handleChange(f.key, e.target.value)}
                  required={f.required}
                  disabled={isEdit && f.key === 'imo_number'}
                />
              </div>
            ))}
          </div>
          {error && <div style={styles.error}>{error}</div>}
          <div style={styles.btnRow}>
            <button type="button" style={styles.cancelBtn} onClick={() => setPage('dashboard')}>Cancel</button>
            <button type="submit" style={styles.submitBtn} disabled={loading}>
              {loading ? 'Saving...' : isEdit ? 'UPDATE VESSEL' : 'ADD VESSEL'}
            </button>
          </div>
        </form>
      </main>
    </div>
  );
}

const styles = {
  wrapper: { minHeight: '100vh', background: 'var(--navy)' },
  header: {
    background: 'var(--navy-mid)', borderBottom: '1px solid var(--navy-border)',
    padding: '0 40px', height: '64px', display: 'flex',
    alignItems: 'center', gap: '20px',
  },
  backBtn: {
    background: 'transparent', border: 'none', color: 'var(--grey)',
    cursor: 'pointer', fontSize: '13px', fontFamily: 'var(--font-display)',
  },
  headerTitle: { fontSize: '16px', fontWeight: '700', flex: 1 },
  headerBadge: {
    fontFamily: 'var(--font-mono)', fontSize: '11px', color: 'var(--gold)',
    border: '1px solid var(--gold)', padding: '4px 10px', borderRadius: '4px',
  },
  main: { padding: '40px', maxWidth: '900px', margin: '0 auto' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px 32px', marginBottom: '32px' },
  field: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: {
    fontSize: '10px', fontWeight: '600', letterSpacing: '1.5px',
    color: 'var(--grey)', fontFamily: 'var(--font-mono)',
  },
  input: {
    background: 'var(--navy-mid)', border: '1px solid var(--navy-light)',
    borderRadius: '8px', padding: '11px 14px', color: 'var(--white)',
    fontSize: '13px', outline: 'none', fontFamily: 'var(--font-mono)',
  },
  error: {
    background: 'rgba(232,0,29,0.1)', border: '1px solid rgba(232,0,29,0.3)',
    borderRadius: '8px', padding: '12px 16px', fontSize: '13px',
    color: '#ff6b7a', marginBottom: '24px',
  },
  btnRow: { display: 'flex', gap: '12px', justifyContent: 'flex-end' },
  cancelBtn: {
    background: 'transparent', border: '1px solid var(--navy-light)',
    color: 'var(--grey)', padding: '12px 24px', borderRadius: '8px',
    fontSize: '13px', cursor: 'pointer',
  },
  submitBtn: {
    background: 'var(--red)', border: 'none', borderRadius: '8px',
    padding: '12px 32px', color: 'white', fontSize: '13px',
    fontWeight: '700', letterSpacing: '1px', cursor: 'pointer',
  },
};
